import React, { useCallback } from 'react';
import _get from 'lodash/get';

import { If } from 'utils';
import { UiKit } from 'components';
import List from './List';
import AddButton from './AddButton';
import { useRequestReasonConfig } from '../../context';

export default function SubReasons() {
  const { data, onChange, isDisabled, isProcessing } = useRequestReasonConfig();

  const isSubReasonAllowed = _get(data, 'allows_sub_reasons', false);
  const subReasonsData = _get(data, 'sub_reasons_data', {});
  const isMultiple = _get(subReasonsData, 'allow_multiple', true);
  const subReasons = _get(data, 'sub_reasons_data.sub_reasons', []);

  const onToggleCheckbox = useCallback(
    value =>
      onChange(
        {
          sub_reasons_data: {
            allow_multiple: value,
            sub_reasons: subReasons
          }
        },
        { runValidation: false }
      ),
    [onChange, subReasons]
  );

  return (
    <>
      <If test={isSubReasonAllowed && !!subReasonsData}>
        <List />
        <UiKit.Checkbox
          label="Allow customers to select more than one reason"
          checked={isMultiple}
          onChange={onToggleCheckbox}
          disabled={isProcessing || isDisabled}
        />
      </If>
      <AddButton />
    </>
  );
}
